import React from "react";
import { openEngineData } from "../../utils/constant";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { Pagination, Autoplay, Navigation } from "swiper/core";
import NormalButton from "./NormalButton";
SwiperCore.use([Autoplay, Pagination, Navigation]);

const { features } = openEngineData;

const Features = () => {
  return (
    <div className="open-engine-features">
      <div className="header">
        <h2 className="subtitle">Everything You Need</h2>
        <h1 className="title">
          Open<span>Engine</span> is that good!
        </h1>
        <p className="desc-1">
          Automatically spins up compute resources in <b>30 secs</b>, <br></br>
          get uninterrupted, cost-effective data querying solutions
        </p>
        <p className="desc-2">
          OpenEngine is built on the core OLAP capabilities of<br></br>{" "}
          the primary warehouse to deliver the below
        </p>
      </div>
      <div className="feature-container desktop">
        {features.map((feature, index) => (
          <div key={index} className="feature">
            <img src={feature.image} alt="" />
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
      <Swiper
        pagination={true}
        className="mySwiper feature-container mobile"
        slidesPerView={1}
        spaceBetween={25}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
      >
        {features.map((feature, index) => (
          <SwiperSlide key={index}>
            <div className="feature">
              <img src={feature.image} alt="" />
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <NormalButton title={"Try for free"} />
    </div>
  );
};

export default Features;
